import React, { useState, useCallback, } from 'react';
import { DecorationWrapper } from './components/DecorationWrapper.js';
import { FieldBase } from './components/FieldBase.js';
/** Controlled text field component - does not handle any other responsibilities beside displaying and
 * controlling the field itself. */
export const TextField = ({ className, defaultValue, id, isDisabled = false, isReadonly = false, inputProps, inputRef, leadingDecoration, onBlur, onChange, onFocus, placeholder, rootProps, size = 'xs', trailingDecoration, type, validationState = 'none', value, name, renderCustomInput, ...rest }) => {
    const [isFocused, setIsFocused] = useState(false);
    const handleBlur = useCallback((event) => {
        setIsFocused(false);
        onBlur?.(event);
    }, [onBlur]);
    const handleChange = useCallback((event) => {
        onChange?.(event.target.value, event);
    }, [onChange]);
    const handleFocus = useCallback((event) => {
        setIsFocused(true);
        onFocus?.(event);
    }, [onFocus]);
    const renderInput = useCallback(() => {
        const InputElement = (React.createElement("input", { "data-test": `${type}-field`, defaultValue: defaultValue, disabled: isDisabled, id: id, name: name, onBlur: handleBlur, onChange: handleChange, onFocus: handleFocus, placeholder: placeholder, readOnly: isReadonly, ref: inputRef, type: type, value: value, ...inputProps, ...rest }));
        return renderCustomInput ? renderCustomInput(InputElement) : InputElement;
    }, [
        defaultValue,
        handleBlur,
        handleChange,
        handleFocus,
        id,
        inputProps,
        inputRef,
        isDisabled,
        isReadonly,
        name,
        placeholder,
        renderCustomInput,
        rest,
        type,
        value,
    ]);
    return (React.createElement(FieldBase, { className: className, isDisabled: isDisabled, hasLeadingDecoration: !!leadingDecoration, hasTrailingDecoration: !!trailingDecoration, isFocused: isFocused, size: size, validationState: validationState, ...rootProps },
        leadingDecoration && (React.createElement(DecorationWrapper, { size: size }, leadingDecoration)),
        renderInput(),
        trailingDecoration && (React.createElement(DecorationWrapper, { size: size }, trailingDecoration))));
};
//# sourceMappingURL=TextField.js.map